export default __webpack_public_path__ + "static/media/alkelio-plus-services.b53f4702.svg";